import { useRoutes } from 'react-router-dom'
import { publicRoutes } from './publicRoutes'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from 'slices/app.slice'
import { Suspense, useEffect } from 'react'
import protectedRoutes from './ProtectedRoutes'
import Fallback from 'components/Fallback'
import Layout from 'components/Layout/Layout'
import { setUserTimeZone } from 'slices/timeZone.slice'

const AppRoutes = () => {
  const dispatch = useDispatch()
  const {
    checked,
    loggedIn,
    me: { role },
  } = useSelector((state) => state.app)

  const routes = checked && loggedIn ? protectedRoutes({ role }) : publicRoutes

  const element = useRoutes(routes)

  useEffect(() => {
    // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const userTimeZone = 'America/New_York'
    // const userTimeZone = 'Asia/Karachi'
    dispatch(setUserTimeZone(userTimeZone))
    dispatch(actions.authenticate())
  }, [])

  return (
    <Suspense fallback={<Fallback />}>
      <Layout {...{ role }}>{element}</Layout>
    </Suspense>
  )
}

export default AppRoutes
